<template lang="pug">
#cart-dropdown(:class="{ active: $store.state.cartDropdownActivated, hover: onHover }")
  .container
    p #[b My Cart,] {{ $store.state.cart.items.length }} items

  // timer icon
  .cart-timer-warning(v-if="$store.state.cart.items.length > 0")
    svg(width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg")
      path(d="M3.00502 9.32576C2.80782 9.9581 2.70166 10.6305 2.70166 11.3273C2.70166 15.0426 5.72465 18.0655 9.44092 18.0655V12.1438H6.14968V10.5108H8.62434V6.0889H9.44092V4.58948C6.42161 4.58948 3.85998 6.5849 3.00502 9.32576Z" fill="white")
      path(d="M10.2575 6.0889V12.1438H9.44092V18.0655C13.1568 18.0655 16.1802 15.043 16.1802 11.3273C16.1802 10.6309 16.074 9.95851 15.8768 9.32576C15.0219 6.5849 12.4598 4.58948 9.44092 4.58948V6.0889H10.2575Z" fill="#DDDDDD")
      path(d="M1.47715 1.8569C-0.214807 3.27917 -0.433243 5.80366 0.989245 7.49578L7.11689 2.34473C5.6944 0.653031 3.16952 0.434628 1.47715 1.8569Z" fill="#3389C5")
      path(d="M17.4046 1.85629C15.7123 0.434018 13.1874 0.652421 11.7649 2.34412L17.8925 7.49516C19.315 5.80305 19.0966 3.27856 17.4046 1.85629Z" fill="#006CB7")
      path(d="M10.2575 6.08887H8.62437V10.5108H6.14972V12.1437H10.2575V6.08887Z" fill="#E3000B")
      path(d="M10.6658 3.0455C10.2657 2.98671 9.85697 2.95569 9.44092 2.95569V4.58942C12.4602 4.58942 15.0219 6.58485 15.8768 9.3257C16.074 9.95805 16.1802 10.6304 16.1802 11.3273C16.1802 15.0426 13.1568 18.0655 9.44092 18.0655V19.6988C14.0579 19.6988 17.8138 15.9431 17.8138 11.3273C17.8138 7.12739 14.7042 3.63988 10.6658 3.0455Z" fill="#006CB7")
      path(d="M2.70169 11.3272C2.70169 10.6304 2.80785 9.95842 3.00505 9.32566C3.86001 6.58481 6.42164 4.58938 9.44095 4.58938V2.95565C9.857 2.95565 10.2661 2.98667 10.6658 3.04546V0.917358H8.21608V3.04546C4.17766 3.63984 1.06812 7.12735 1.06812 11.3272C1.06812 15.9431 4.82399 19.6988 9.44095 19.6988V18.0654C5.72509 18.0654 2.70169 15.0425 2.70169 11.3272Z" fill="#3389C5")

    p Item added to cart! We'll hold it for 15 minutes.
  .cart-items
    .cart-item(v-for="item in $store.state.cart.items")
      .image-container
        img(v-if="item.image" :src="`/uploads/images/products/${item.image}`", @error="loadPlacholder($event)")
      .description-container(v-if="item.is_sale === 1")
        p.title {{ item.displayText }}
        p.price #[b RM{{ priceFormat(item.discounted_price * item.quantity) }}]
        p.quantity Qty {{ item.quantity }}
      .description-container(v-else)
        p.title {{ item.displayText }}
        p.price(v-if="item.is_reward === 1") #[b FREE]
        p.price(v-else) #[b RM{{ priceFormat(item.price * item.quantity) }}]
        p.quantity Qty {{ item.quantity }}
  .button-container
    router-link(to="/cart")
      button.blue-button Go To Cart
</template>

<script>
export default {
  props: ['onHover'],
  methods: {
    priceFormat (num) {
      return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    loadPlacholder (event) {
      event.target.src = `/uploads/images/placeholder.png`
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../sass/_variables.sass'

#cart-dropdown
  position: fixed
  width: 400px
  z-index: 100
  background-color: $yellow
  right: 0
  top: 0
  border: 1px solid white
  transition: 0.5s transform
  transform: translateY(-150%)
  transition-delay:0.3s
  +mobile
    width: 90vw
  &.active
    transform: translateY(0)
  &.hover
    position: absolute
    z-index: 100
    transform: translateY(-101%)
    &:after
      content: ''
      width: 0
      height: 0
      border-left: 10px solid transparent
      border-right: 10px solid transparent
      border-bottom: 12px solid #006CB7
      position: absolute
      top: -12px
      right: 22px
  .container
    background-color: #006CB7
    color: white
    p
      padding: 20px 30px
      font-size: 20px
      +mobile
        padding: 10px 20px
        font-size: 16px
  .cart-timer-warning
    background: #EAEAEA
    padding: 5.5px 30px
    display: flex
    align-items: center
    p
      font-size: 12px
      line-height: 34px
      font-style: italic
      margin-left: 14px
  .cart-items
    max-height: calc(100vh - 64px - 76px)
    overflow: auto
    +mobile
      max-height: calc(100vh - 73px - 16px - 38px - 90px)
    &::-webkit-scrollbar
      -webkit-appearance: none
    &::-webkit-scrollbar:vertical
      width: 11px
    &::-webkit-scrollbar:horizontal
      height: 11px
    &::-webkit-scrollbar-thumb
      border-radius: 8px
      border: 2px solid white
      background-color: rgba(0, 0, 0, 0.5)
    .cart-item
      display: flex
      position: relative
      padding: 20px 0px
      margin: 0 30px
      border-bottom: 1px solid black
      +mobile
        margin: 0 10px
        padding: 10px 0
      &:last-child
        border-bottom: none
      .image-container
        flex: 0 0 40%
        img
          width: 100%
      .description-container
        padding-left: 20px
        +mobile
          font-size: 14px
          padding-left: 10px
        .title
          margin-bottom: 15px
          +mobile
            margin-bottom: 5px
        .price
          margin-bottom: 15px
          +mobile
            margin-bottom: 5px
      .delete-icon
        position: absolute
        bottom: 10px
        right: 0px
        cursor: pointer
  .button-container
    padding: 10px 30px 15px 30px
    +mobile
      padding: 10px 20px 15px 20px
    .blue-button
      width: 100%
      margin: 0 auto
      display: block
      +mobile
        font-size: 15px
</style>
